window.addEventListener('DOMContentLoaded', () => {
    const mainBody = document.querySelector('body');

    let mobileMenuLinks = document.querySelectorAll('.main-menu .menu-item');
    let mobileChildMenus = document.querySelectorAll('.childmenu');
    let mobileChildMenuItems = document.querySelectorAll('.childmenu-item');
    let mobileGrandChildMenus = document.querySelectorAll('.grandchildmenu');
    let menuButton = document.querySelector('.o-menu-trigger');

    let novaMobileMenu = document.querySelector('nova-menu-drawer');
    let novaMobileNav = document.querySelector('nova-menu-drawer nav');

    /*----- Adjust mobile menu height -----*/
    const mainHeaderHeight = document.querySelector('#l-header-main').offsetHeight;
    const announcementBarHeight = document.querySelector('#announcement-bar').offsetHeight;
    let headerTotalHeight = mainHeaderHeight + announcementBarHeight - 1;

    novaMobileNav.style.height = 'calc(100vh - ' + headerTotalHeight + 'px)';

    /*----- Open mobile menu, lock body -----*/
    menuButton.addEventListener('click', function (event) {
        novaMobileMenu.classList.toggle('active');
        mainBody.classList.toggle('mobile-menu-opened');
    });


    /*----- Open childmenu on click on level 1 -----*/
    mobileMenuLinks.forEach(function(e) {
        let childMenu = e.querySelector('.childmenu');
        if(childMenu) {
            e.addEventListener('click', function (event){
                event.stopPropagation();
                childMenu.classList.add('active');
                novaMobileNav.classList.add('overflow-hidden');
                novaMobileNav.scrollTop = 0;
            });
        }
    });

    /*----- Open grandchildmenu on click on level 2 -----*/
    mobileChildMenuItems.forEach(function(e) {
        let grandChildMenu = e.querySelector('.grandchildmenu');
        if(grandChildMenu) {
            e.addEventListener('click', function (event){
                event.stopPropagation();
                grandChildMenu.classList.add('active');
                mobileChildMenus.forEach(function(event) {
                    event.classList.add('overflow-hidden');
                    event.scrollTop = 0;
                });
            });
        }
    });

    /*----- Close child menu with back button -----*/
    mobileChildMenus.forEach(function(e) {
        let childBackBtn = e.querySelector('.child-back-btn');
        childBackBtn.addEventListener('click', function (event) {
            if ( e.classList.contains('active')) {
                event.stopPropagation();
                e.classList.remove('active');
            }

            if ( novaMobileNav.classList.contains('overflow-hidden')) {
                novaMobileNav.classList.remove('overflow-hidden');
            }
        });

        e.style.height = 'calc(100vh - ' + headerTotalHeight + 'px)';
    });

    /*----- Close grandchild menu with back button -----*/
    mobileGrandChildMenus.forEach(function(e) {
        let childBackBtn = e.querySelector('.child-back-btn');
        childBackBtn.addEventListener('click', function (event) {
            if ( e.classList.contains('active')) {
                event.stopPropagation();
                e.classList.remove('active');

                mobileChildMenus.forEach(function(event) {
                    if (event.classList.contains('overflow-hidden')) {
                        event.classList.remove('overflow-hidden');
                    };
                });
            }
        });

        e.style.height = 'calc(100vh - ' + headerTotalHeight + 'px)';
    });

    /*----- Close submenus if mobile menu is closed -----*/
    menuButton.addEventListener('click', function (event) {
        mobileChildMenus.forEach(function(e) {
            if (e.classList.contains('active')) {
                e.classList.remove('active');
            }
            if (e.classList.contains('overflow-hidden')) {
                e.classList.remove('overflow-hidden');
            }
        });
        mobileGrandChildMenus.forEach(function(e) {
            if (e.classList.contains('active')) {
                e.classList.remove('active');
            }
        });

        if ( novaMobileNav.classList.contains('overflow-hidden')) {
            novaMobileNav.classList.remove('overflow-hidden');
        }
    });
});